import React from "react";

const Spinner = ({ scale = 5, color = "#0F1A52" }) => {

  // Calculating proper scale value
  const scaleValue = scale / 10;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <svg
        width={120 * scaleValue}
        height={120 * scaleValue}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Loading"
      >
        <g transform="translate(50 50)">
          {/* Middle circle */}
          <circle fill={color} r="9">
            <animate
              attributeName="r"
              values="9;11;9;14;9"
              keyTimes="0;0.2;0.66;0.9;1"
              dur="5s"
              repeatCount="indefinite"
            />
          </circle>

          {/* Group that will scale */}
          <g id="scaleGroup">
            {/* Group that will rotate (orbit motion) */}
            <g id="orbitGroup" fill={color}>
              <circle r="7" transform="translate(0,-24)" />
              <circle r="7" transform="translate(24,0)" />
              <circle r="7" transform="translate(0,24)" />
              <circle r="7" transform="translate(-24,0)" />

              <animateTransform
                attributeName="transform"
                type="rotate"
                values="0;360;720;720"
                keyTimes="0;0.33;0.66;1"
                dur="5s"
                repeatCount="indefinite"
              />
            </g>

            {/* Scale group: small breathing + final merge to center */}
            <animateTransform
              attributeName="transform"
              type="scale"
              values="1;1.1;1;1;0"
              keyTimes="0;0.16;0.33;0.66;1"
              dur="5s"
              repeatCount="indefinite"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Spinner;